import React from "react";
import styled from "styled-components";
import renderButtons from "../helpers/renderButtons";
import { get } from "lodash";
import PrismicRichText from "../components/PrismicRichText";

const StlRoot = styled.section`
  padding: 36px 32px;
  @media (min-width: 900px) {
    min-height: 550px;
    display: flex;
  }
`;

const StlInner = styled.div`
  max-width: 1480px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 900px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 80px;
    padding: 56px;
  }
`;

const StlCopy = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 28px;

  @media (min-width: 900px) {
    width: 58%;
    text-align: left;
    gap: 48px;
  }
`;

const StlHeading = styled.div`
  h1 {
    margin: 0;
  }
  margin: 0;
`;

const StlButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  align-items: center;

  @media (min-width: 900px) {
    flex-direction: row;
    align-items: center;
    gap: 52px;
  }
`;

const StlVisual = styled.div`
  width: 86%;
  max-width: 420px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 900px) {
    width: 42%;
    max-width: 520px;
  }
`;

const StlHalfVisual = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StlHalfImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const StlOval = styled.figure`
  margin: 60px 0 0 0;
`;

const StlOvalImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: inherit;
  position: relative;
`;

const Hero = (slice) => {
  const buttons = slice?.items;
  const halfImageLayout = get(slice, "primary.half_image_layout");

  return (
    <StlRoot
      style={{
        background: get(slice, "primary.background_color"),
        color: get(slice, "primary.text_color"),
      }}
    >
      <StlInner>
        <StlCopy>
          <StlHeading>
            <PrismicRichText render={get(slice, "primary.content")} />
          </StlHeading>
          <StlButtons>{renderButtons(buttons)}</StlButtons>
        </StlCopy>
        {get(slice, "primary.image.url") &&
          (halfImageLayout ? (
            <StlHalfVisual>
              <StlHalfImage src={get(slice, "primary.image.url")} alt="Hero" />
            </StlHalfVisual>
          ) : (
            <StlVisual>
              <StlOval role="img" aria-label="Hero visual">
                <StlOvalImage
                  src={get(slice, "primary.image.url")}
                  alt="Hero"
                />
              </StlOval>
            </StlVisual>
          ))}
      </StlInner>
    </StlRoot>
  );
};

export default Hero;
